//
// Action types
//

export const UPDATE_FIELD_VALUE = "UPDATE_FIELD_VALUE";

//
// Action creators
//

export function updateFieldValue(formKey, key, value) {
  return {
    type: UPDATE_FIELD_VALUE,
    formKey,
    key,
    value
  };
}

function updateFieldValueHandler(state, key, value) {
  return { ...state, [key]: value };
}

//
// Reducer and handlers
//

export function reduceFields(state, action) {
  switch (action && action.type) {
    case UPDATE_FIELD_VALUE:
      return updateFieldValueHandler(state, action.key, action.value);

    default:
      return state || {};
  }
}
